module.exports = __webpack_public_path__ + "media/images/expert__lutz-pfannenstiel-fa24e20f6a86eab800c6fbfdf79afac5.png";